import React from "react";
import {FaBuilding, FaEnvelope, FaPhone} from "react-icons/fa";
import BaseNode from "./base-node.jsx";
import CheckHasData from "../check-has-data.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import {Types} from "../enums.js";

const Company = ({data, selected}) => {
    const icon = (<FaBuilding size={16} color={"#031b34"}/>);

    const title = (
        <div className={"w-24.25"}>
            <p className={"mb-0.5!"}>
                <b className={"block overflow-hidden whitespace-nowrap text-ellipsis"}>
                    {data.name || "Empresa"}
                </b>
            </p>
            <p className={"mb-0 text-[6px]"}>
                <CheckHasData value={projectUtils.formatCnpjToView(data.value)} colorText={"#fff"} />
            </p>
        </div>
    )

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            <div className={"flex items-center"}>
                <FaEnvelope/>
                <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                    <CheckHasData value={data.email} />
                </p>
            </div>
            <div className={"flex items-center"}>
                <FaPhone/>
                <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                    <CheckHasData value={data.phone} />
                </p>
            </div>
        </div>
    );

    return (
        <BaseNode
            icon={icon}
            title={title}
            infoBlock={infoBlock}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#8eacea]"}
            bgBody={"bg-[#d1d7e3]"}
            type={Types.COMPANY}
        />
    );
}

export default Company;
